import { Component } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "app-upgrade",
  templateUrl: "./upgrade.component.html",
  styleUrls: ["./upgrade.component.scss"],
})
export class UpgradeComponent {
  form = {
    plan: "",
    currentPlanPrice: 0,
    newPlanPrice: 0,
    requiredPayment: 0,
    cashPaid: 0,
    visaPaid: 0,
    contactlessCashPaid: 0,
    dueDate: "2026-02-19",
    dueNote: "",
    note: "",
  };

  plans = [
    // populate from API
    { value: "", label: "Select a plan" },
  ];

  benefits = [
    { key: "MaxMassage", label: "Massage", value: 0 },
    { key: "MaxInbody", label: "Inbody", value: 0 },
    { key: "MaxMeditation", label: "Meditation", value: 0 },
    { key: "MaxCupping", label: "Cupping", value: 0 },
    { key: "MaxInvitations", label: "Invitation", value: 0 },
    { key: "MaxPTSessions", label: "PTSessions", value: 0 },
    { key: "MaxFitness", label: "Fitness", value: 0 },
    { key: "MaxNutrations", label: "Nutration", value: 0 },
    { key: "MaxFreeDays", label: "FreeDays", value: 0 },
    { key: "MaxTraining", label: "Training", value: 0 },
    { key: "MaxCashBack", label: "Cash Back", value: 0 },
    { key: "MaxFreeze", label: "Freezes", value: 0 },
    { key: "MaxKidsArea", label: "KidsArea", value: 0 },
  ];

  attendanceDays = [
    { name: "Saturday", from: "00:00", to: "23:59" },
    { name: "Sunday", from: "00:00", to: "23:59" },
    { name: "Monday", from: "00:00", to: "23:59" },
    { name: "Tuesday", from: "00:00", to: "23:59" },
    { name: "Wednesday", from: "00:00", to: "23:59" },
    { name: "Thursday", from: "00:00", to: "23:59" },
    { name: "Friday", from: "00:00", to: "23:59" },
  ];

  constructor(private dialogRef: MatDialogRef<UpgradeComponent>) {}

  onPlanChange(): void {
    // fetch new plan price from API and update form.currentPlanPrice / newPlanPrice
  }

  calcRequired(): void {
    this.form.requiredPayment =
      this.form.newPlanPrice - this.form.currentPlanPrice;
  }

  submit(): void {
    this.dialogRef.close({
      form: this.form,
      benefits: this.benefits,
      attendance: this.attendanceDays,
    });
  }

  close(): void {
    this.dialogRef.close();
  }
}
